import * as angular from "angular";

angular
  .module('bringoz.admin.oms')
  .filter('omsPackageSpots', omsPackageSpots);

function omsPackageSpots() {
  return function bringozOmsPackageSpots(packageRef) {
    if (!packageRef || !packageRef.requiredSpots) {
      return '--';
    }

    return packageRef.requiredSpots * (packageRef.count || 1);
  };
}
